import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Row from '@prism/row';
import PrismCol from './PrismCol';
import PrismCheckbox from '../../checkbox/prismCheckbox';

import { COLUMN_PROP_TYPES } from '../constants';
import { DATA_FORMAT_TYPES } from '../../../../constants';

class PrismGridHeader extends React.Component {
    static propTypes = {
        columns: PropTypes.arrayOf(COLUMN_PROP_TYPES).isRequired,
        className: PropTypes.string,
        selectAll: PropTypes.bool,
        hideSelectAll: PropTypes.bool,
        onSelectAllRows: PropTypes.func
    };

    static defaultProps = {
        headerClassName: '',
        selectAll: false,
        hideSelectAll: false,
        onSelectAllRows: () => { }
    };

    renderHeaderColumns = ({
        columns,
        selectAll,
        hideSelectAll,
        onSelectAllRows
    }) => (
        <>
            {columns.map((column, index) => {
                    if (column.isHidden) {
                        return false
                    }

                    const isSelectColumn = column.dataFormat === DATA_FORMAT_TYPES.SELECT;
                    const columnClassName = classNames(
                        'prism-grid__header-column',
                        { 'prism-grid__header-column_select': isSelectColumn }
                    );
                    const node = isSelectColumn && !hideSelectAll
                        ? (
                            <PrismCheckbox
                                id="select-all"
                                checkboxClassName="prism-grid__header-column_select-control"
                                checked={selectAll}
                                onChange={onSelectAllRows}
                            />
                        )
                        : column.name;

                    return (
                        <React.Fragment key={`header-column_${index}`}>
                            <PrismCol
                                className={columnClassName}
                                title={isSelectColumn ? 'Select all' : column.name}
                                colProps={{
                                    md: column.md,
                                    lg: column.lg,
                                    xl: column.xl,
                                }}
                            >
                                {node}
                            </PrismCol>
                        </React.Fragment>
                    );
                })}
        </>
    )

    render() {
        const { className } = this.props;

        const containerClassName = classNames(
            'prism-grid__header',
            className
        );

        return (
            <div className={containerClassName}>
                <Row className="prism-grid__header-columns-container">
                    {this.renderHeaderColumns(this.props)}
                </Row>
            </div>
        );
    }
}

export default PrismGridHeader;
